import { useQuery } from '@tanstack/react-query'
import RestocksApi from '@/infrastructure/api/restocks'

export const processRestocksKey = (processId?: string) =>
  ['processRestocks', processId] as const

export function useProcessRestocks(processId?: string) {
  async function callProcessRestocks() {
    if (!processId) return
    return RestocksApi.getRestocks({ processId })
  }

  const processRestocksQuery = useQuery({
    queryKey: processRestocksKey(processId),
    queryFn: callProcessRestocks,
    staleTime: 1000 * 60 * 15,
    enabled: !!processId
  })

  return {
    restocks: processRestocksQuery.data ?? [],
    loadingRestocks: processRestocksQuery.isLoading
  }
}
